import React from "react";
import { Treemap } from "recharts";
import { ChartStrategy } from "./ChartStrategy";
import { DYCHARTCOLORS } from "../../../../core/constants/chartStyles";

export class TreemapStrategy extends ChartStrategy {
  render() {
    return (
      <Treemap
        data={this.props.normalizedData}
        dataKey={this.props.yAxis}
        nameKey={this.props.xAxis}
        stroke="#fff"
        content={({ x, y, width, height, name, value, index }) => (
          <g>
            <rect
              x={x}
              y={y}
              width={width}
              height={height}
              fill={DYCHARTCOLORS[index % DYCHARTCOLORS.length]}
              stroke="#fff"
            />
            <text
              x={x + width / 2}
              y={y + height / 2}
              textAnchor="middle"
              fill="#fff"
              fontSize={12}
            >
              {`${name}: ${value}`}
            </text>
          </g>
        )}
      />
    );
  }
}
